import React, { useState, useEffect } from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Button from "../../atoms/button/button";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";
import useDirectionScroll from "../../../shared/hooks/useDirectionScroll";
import {
    normalizeTwoWords,
    OptimizeImage,
} from "../../../shared/utils/stringUtilities";
import "./headboardSalaPrensa2.scss";
import SearchContent from "../../../components/molecules/search-content/searchContent"
import { isMobile } from "../../../utils/helpers";

const HeadboardSalaPrensa2 = (props: ReferenciaCabecera) => {
    const {  window, document, sessionStorage } = useBrowserMode();
    const { refElement } = useScrollDetect();
    const [showProtect, setShowProtect] = useState(true);


    const handlePopup = () => {
        setShowProtect(false);
        sessionStorage.setItem("popup", "off");
    };

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    useEffect(() => {
        if (localStorage.getItem("hashSection")) {
            const section: any = document.getElementById(
                localStorage.getItem("hashSection")
            );
            window.scrollTo({
                top: section?.offsetTop - 180,
                behavior: "smooth",
            });
        }
    }, []);

    return (
        <>
            <div className="o-headboard-sala-prensa2" ref={refElement}>
                <div className="o-banner-headboard">
                    <div className="o-banner-headboard-container2">
                        <div className="container">
                            <div className={`banner-headboard-text2 ${props.contentful_id === "3dethgN299xJPKwMbsZu4j"? "textEncTal" : ""}`}>
                                <span>{props.tituloPrincipal}</span>
                                {props.tituloSpan && (
                                    <p className="banner-headboard-text__subtitle">
                                        {props.tituloSpan}
                                    </p>
                                )}

                                {props.contentful_id === "3dethgN299xJPKwMbsZu4j" &&
                                    !isMobile() && (
                                    <SearchContent type="encontrarTalento" />
                                )}

                                {props.tituloBoton && (
                                    <div className="banner-headboard-text__buttons">
                                        <div className="banner-headboard-text__buttons__item">
                                            <Button
                                                type="link"
                                                text={props.tituloBoton}
                                                classname={`a-button__magenta`}
                                                href={props.redireccionBoton}
                                                isDisabled={false}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {props.imagenHeader && !isMobile() && (
                            <img
                                className="banner-headboard-image2"
                                src={OptimizeImage(
                                    props.imagenHeader.file.url,
                                    props.imagenHeader.file.contentType,
                                    props.imagenHeader.file.details.image.width
                                )}
                                alt={
                                    props.imagenHeader.description ||
                                    "imagen cabecera sala de prensa"
                                }
                                loading="lazy"
                            />
                        )}
                        {props.imagenMobile && isMobile() && (
                            <img
                                className="banner-headboard-image2"
                                src={OptimizeImage(
                                    props.imagenMobile.file.url,
                                    props.imagenMobile.file.contentType,
                                    props.imagenMobile.file.details.image.width
                                )}
                                alt={
                                    props.imagenMobile.description ||
                                    "imagen cabecera sala de prensa"
                                }
                                loading="lazy"
                            />
                        )}
                    </div>
                </div>
            </div>
            {props.imagenLogo && !sessionStorage.getItem("popup") && (
                <div
                    className="banner-headboard-text__logo"
                    style={{ display: `${showProtect ? "flex" : "none"}` }}
                >
                    <span onClick={handlePopup}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.536"
                            height="17.536"
                            viewBox="0 0 17.536 17.536"
                        >
                            <g id="x" transform="translate(1.768 1.768)">
                                <line
                                    id="Línea_80"
                                    data-name="Línea 80"
                                    x1="14"
                                    y2="14"
                                    transform="translate(0 0)"
                                    fill="none"
                                    stroke="#303030"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.5"
                                />
                                <line
                                    id="Línea_81"
                                    data-name="Línea 81"
                                    x2="14"
                                    y2="14"
                                    transform="translate(0 0)"
                                    fill="none"
                                    stroke="#303030"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2.5"
                                />
                            </g>
                        </svg>
                    </span>
                    <img
                        src={props.imagenLogo.file.url}
                        alt={props.imagenLogo.description || "Imagen"}
                    />
                    {props.descripcion &&
                        documentToReactComponents(props.descripcion.json)}
                </div>
            )}
        </>
    );
};

export default HeadboardSalaPrensa2;
